module.exports = __webpack_public_path__ + "img/bb_g3_eyes-04.7453839d.svg";